(function(){
  if (window.__nmV21Applied) return;
  window.__nmV21Applied = true;

  function norm(s){
    return String(s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'')
      .replace(/[^a-z0-9+\s-]/g,' ')
      .replace(/\s+/g,' ')
      .trim();
  }

  function widgetRoot(){ return document.getElementById('nmChatWidget'); }
  function inWidget(node){ var root = widgetRoot(); return !!(root && node && root.contains(node)); }

  function openNewTabSafe(url, allowSameTabFallback){
    if (!url) return false;
    try {
      var a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      a.rel = 'noopener noreferrer';
      a.style.position = 'fixed';
      a.style.left = '-9999px';
      a.style.top = '-9999px';
      document.body.appendChild(a);
      a.click();
      setTimeout(function(){ try { a.remove(); } catch(_e){} }, 0);
      return true;
    } catch (e) {}
    try {
      var win = window.open(url, '_blank', 'noopener,noreferrer');
      if (win && typeof win.focus === 'function') { win.focus(); return true; }
      if (win) return true;
    } catch (e2) {}
    if (allowSameTabFallback) {
      try { window.location.href = url; return true; } catch (e3) {}
    }
    return false;
  }

  function openWidgetIfNeeded(){
    var root = widgetRoot();
    if (root && root.classList.contains('nm-active')) return;
    var fab = document.getElementById('nmChatFab');
    if (fab) fab.click();
  }

  function sendAssistantTopic(topic){
    if (!topic) return;
    openWidgetIfNeeded();
    setTimeout(function(){
      var input = document.getElementById('nmChatInput');
      var send = document.getElementById('nmChatSend');
      if (!input || !send) return;
      input.value = topic;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      send.click();
    }, 80);
  }

  function handleQuickButton(button){
    var label = norm(button.textContent);
    var topic = null;
    if (label.indexOf('necesito colina') !== -1) topic = 'alpha gpc';
    else if (label.indexOf('noopept vs piracetam') !== -1) topic = 'noopept vs piracetam';
    else if (label.indexOf('stack para estudiar') !== -1 || label.indexOf('stack examen') !== -1) topic = 'actividad:examen';
    else if (label.indexOf('ver stacks completos') !== -1) topic = 'stacks';
    else if (label.indexOf('soy principiante') !== -1 || label.indexOf('stack basico') !== -1) topic = 'principiante';
    else if (label.indexOf('quiz express') !== -1) topic = 'quiz express';
    else if (label.indexOf('stack deep work') !== -1) topic = 'actividad:deep-work';
    else if (label.indexOf('comparar opciones') !== -1) topic = 'alpha-gpc vs cdp';
    else if (label.indexOf('anti-estres') !== -1 || label.indexOf('anti estres') !== -1) topic = 'calma';
    else if (label.indexOf('mejor sueno') !== -1 || label.indexOf('mejor sueño') !== -1) topic = 'sueno';
    else if (label.indexOf('noopept') === 0) topic = 'noopept';
    else if (label.indexOf('dosis') === 0) topic = 'dosis';
    if (topic) { sendAssistantTopic(topic); return true; }
    return false;
  }

  function handleQuizHubButton(button){
    var label = norm(button.textContent);
    // Para quiz express y personalizado: NO interceptar — dejar que btn.onclick corra
    // Solo interceptar WhatsApp que no tiene onclick nativo
    if (label.indexOf('hablar con humano') !== -1) {
      openNewTabSafe('https://wa.me/525542463084?text=Hola%2C%20quiero%20asesor%C3%ADa%20personalizada%20de%20nootr%C3%B3picos', true);
      return true;
    }
    // Devolver false para que btn.onclick del hub maneje quiz express y personalizado
    return false;
  }

  document.addEventListener('click', function(e){
    var target = e.target;
    if (!inWidget(target)) return;

    var qr = target.closest('.nm-qr-btn, .nm-welcome__trend-pill');
    if (qr && handleQuickButton(qr)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }

    var quiz = target.closest('.nm-quiz-hub__option');
    if (quiz && handleQuizHubButton(quiz)) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return;
    }

    var link = target.closest('a[href]');
    if (link && inWidget(link)) {
      var href = link.getAttribute('href') || '';
      if (href && href !== '#' && href.indexOf('javascript:') !== 0) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openNewTabSafe(link.href, false);
        return;
      }
    }
  }, true);
})();
